<template>
  <CustomPage title="申请申诉" :noBorder="true" style="background: #f7f7f7">
    <div slot="content">
      <div class="in-sale-container pb-20 px-3 pt-3">
        <div class="bg-white px-3 py-2 rounded-lg">
          <div>申诉商品</div>
          <div class="flex items-center">
            <div class="flex flex-grow">
              <div
                class="w-20 h-20 mr-2"
                v-for="(item, index) in items"
                :key="index"
                v-show="index < 4"
              >
                <img
                  class="h-full w-full rounded-md"
                  :src="item.imgUrl"
                  alt=""
                />
              </div>
            </div>
            <div class="mr-2">
              <span
                >共{{ items.reduce((prev, cur) => prev + cur.qty, 0) }}件</span
              ><span class="ml-3"></span>
            </div>
          </div>
        </div>
        <div class="bg-white px-3 py-2 rounded-lg mt-2">
          <div><span class="required">*</span>申诉商品</div>
          <div>
            <Cell
              title="货物状态"
              is-link
              :value="goodsStateStr"
              @click="showGoodsStatus = true"
            />
            <Cell
              title="退款原因"
              is-link
              :value="calcParams.appealReason"
              @click="showAppealReason = true"
            />

            <Cell title="退款金额" label="不可修改"
              ><template #right-icon>
                <span class="text-red font-semibold"
                  >￥{{ calcParams.claimAmount }}</span
                ></template
              ></Cell
            >
          </div>
        </div>

        <div class="bg-white px-3 py-2 rounded-lg mt-2">
          <div><span class="required">*</span>补充描述和凭证</div>
          <div>
            <Field
              v-model="calcParams.description"
              rows="2"
              autosize
              type="textarea"
              placeholder="补充描述，有助于平台更好处理售后问题（100字以内）"
            />
          </div>
        </div>
        <div class="bg-white px-3 py-2 rounded-lg mt-2">
          <div>上传凭证</div>
          <!-- <span class="required">*</span> -->
          <div class="flex items-end">
            <Uploader v-model="fileList" multiple :max-count="1" />
            <div class="text-xs text-gray">
              仅支持jpg、jpeg、png、gif文件，仅限上传1张，大小不超过5M
            </div>
          </div>
        </div>
        <div class="w-full px-8 absolute" style="bottom: 30px">
          <Button
            style="
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
              color: white;
            "
            size="large"
            class="h-8 rounded-full"
            @click="submit"
            >确定</Button
          >
        </div>
      </div>
      <ActionSheet v-model="showGoodsStatus" title="货物状态">
        <div class="content px-3">
          <div style="color: #808080" class="text-sm px-4">请选择货物状态</div>
          <RadioGroup v-model="goodsStateStr">
            <CellGroup>
              <Cell
                title="未收到货"
                clickable
                @click="goodsStateStr = '未收到货'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="未收到货" />
                </template> </Cell
              ><Cell
                title="已收到货"
                clickable
                @click="goodsStateStr = '已收到货'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="已收到货" />
                </template>
              </Cell>
            </CellGroup>
          </RadioGroup>
          <div class="flex justify-center my-3">
            <Button
              class="rounded-full"
              size="large"
              style="
                box-sizing: border-box;
                border-color: #e82035;
                color: #e82035;
                height: 32px;
                width: 70%;
              "
              @click="showGoodsStatus = false"
              >关闭</Button
            >
          </div>
        </div>
      </ActionSheet>
      <ActionSheet v-model="showAppealReason" title="申诉原因">
        <div class="content px-3">
          <div style="color: #808080" class="text-sm px-4">请选择申诉原因</div>
          <RadioGroup v-model="calcParams.appealReason">
            <CellGroup v-if="goodsStateStr === '已收到货'">
              <Cell
                v-for="item in [
                  '商品描述不符',
                  '商品质量有问题',
                  '商家少发/漏发/错发',
                  '包装/商品破损/污渍',
                  '未按约定时间发货',
                  '其他',
                ]"
                :key="item"
                :title="item"
                clickable
                @click="calcParams.appealReason = item"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" :name="item" />
                </template>
              </Cell>
            </CellGroup>
            <CellGroup v-else-if="goodsStateStr === '未收到货'"
              ><Cell
                v-for="item in [
                  '不喜欢/不想要',
                  '空包裹',
                  '未按约定时间发货',
                  '物流/快递一直未送到',
                  '物流/快递无跟踪记录',
                  '货物破损已拒签',
                ]"
                :key="item"
                :title="item"
                clickable
                @click="calcParams.appealReason = item"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" :name="item" />
                </template> </Cell
            ></CellGroup>
          </RadioGroup>
          <div class="flex justify-center my-3">
            <Button
              class="rounded-full"
              size="large"
              style="
                box-sizing: border-box;
                border-color: #e82035;
                color: #e82035;
                height: 32px;
                width: 70%;
              "
              @click="showAppealReason = false"
              >关闭</Button
            >
          </div>
        </div>
      </ActionSheet>
    </div>
  </CustomPage>
</template>

<script>
import { calcReturnMoney, applyAftSale } from "./webApi";
import { uploadImage } from "@/api/index";
import CustomPage from "@/components/custom-page.vue";
import {
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  ActionSheet,
  Button,
  Field,
  Uploader,
  Toast,
} from "vant";
export default {
  components: {
    CustomPage,
    Cell,
    CellGroup,
    Radio,
    RadioGroup,
    ActionSheet,
    Button,
    Field,
    Uploader,
  },
  created() {
    let params = this.$route.params;
    console.log(params);
    this.items = params.items;
    this.aftSaleReason = params.aftSaleReason;
    this.orderNo = params.id;
    this.actId = params.actId;
    this.calcParams = {
      refundOnly: params.aftSaleReason === "我要退货退款" ? false : true,
      serverType:
        params.aftSaleReason === "我要退货退款"
          ? "RETURNS_AND_REFUNDS"
          : "REFUND",
      orderNo: params.id,
      orderItems: params.items,
      appealReason: null,
      claimAmount: null,
      description: null,
      evidence: null,
      allRefund: params.allRefund,
      actId: params.actId,
    };
    console.log(this.calcParams);
    calcReturnMoney(this.calcParams).then((res) => {
      this.calcParams.claimAmount = res.data;
    });
  },
  data() {
    return {
      items: [],
      aftSaleReason: "",
      goodsStateStr: "",
      orderNo: null,
      showGoodsStatus: false,
      showAppealReason: false,
      fileList: [],
      calcParams: {},
      uploadedImage: null,
    };
  },
  methods: {
    sendAftSaleReq() {
      applyAftSale(this.calcParams).then((res2) => {
        if (res2.data) {
          this.$router.replace({
            path: "/mine/order/afterSale",
            query: { id: res2.data },
          });
        } else {
          Toast({
            message: res2.message,
            position: "center",
            duration: 1000,
          });
          this.$router.replace({
            name: "Order",
          });
        }
      });
    },
    submit() {
      if (!this.calcParams.appealReason) return;
      this.calcParams.goodsState = {
        未收到货: "NOT_YET_SHIPPED",
        已收到货: "RECEIVED_GOODS",
      }[this.goodsStateStr];
      const params = new FormData();

      try {
        this.uploadedImage = false;
        params.append("file", this.dataURLtoBlob(this.fileList[0].content));
        this.uploadedImage = true;
      } catch (error) {
        console.error(error);
        this.sendAftSaleReq();
      }
      if (!this.uploadedImage) return;
      uploadImage(params).then(({ data }) => {
        this.calcParams.evidence = data;
        this.sendAftSaleReq();
      });
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
  },
};
</script>

<style lang="less" scoped>
.required {
  color: red;
  font-weight: bold;
}
</style>
